export default __webpack_public_path__ + "static/media/payment.3c98e392.png";